import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.938 8.625V5.25c0-.31.253-.562.562-.562h8.068c.148 0 .292.06.398.165l.931.931c.106.106.166.25.166.398v2.443h1.687V6.182a2.25 2.25 0 0 0-.657-1.593l-.936-.932A2.24 2.24 0 0 0 15.568 3H7.5a2.25 2.25 0 0 0-2.25 2.25v3.375zm.562 7.313h9v3.374h-9zm-.562-1.688c-.623 0-1.125.503-1.125 1.125H4.688V12c0-.31.253-.562.562-.562h13.5c.31 0 .563.253.563.562v3.375h-1.125c0-.622-.503-1.125-1.125-1.125zm11.25 2.813h1.687c.622 0 1.125-.503 1.125-1.125V12a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 12v3.938c0 .622.503 1.124 1.125 1.124h1.688v2.813c0 .622.502 1.125 1.125 1.125h10.125c.622 0 1.125-.503 1.125-1.125z"
    }, null, -1)
  ]))]))
}
export default { render: render }